<template>
  <div class="modify">
    <div class="modify-tip">
      <div v-if="getShowWaitConfirm(allLists) > 0">
        <span class="modify-tip-left">
          当前有
          <span style="color:red">{{ getShowWaitConfirm(allLists) }}</span
          >份“产品修改单清单”等待确认,确认后将投入生产。
        </span>
        <span class="modify-tip-right">
          <i
            class="iconfont icon-jinggao"
            style="color: #FFAA00; font-size:19px;vertical-align: bottom;"
          ></i
          >修改清单一经确认，相应增减项费用将计入尾款
        </span>
      </div>

      <div v-if="getShowWaitConfirm(allLists) === 0">
        <span class="modify-tip-left">
          <i
            class="iconfont icon-jinggao"
            style="color: #FFAA00; font-size:19px;vertical-align: bottom;"
          ></i>
          修改清单一经确认，相应增减项费用将计入尾款
        </span>
      </div>
    </div>
    <Row
      type="flex"
      justify="start"
      align="middle"
      class="modify-row"
      v-for="(orderModify, index) in lists"
      :key="index"
    >
      <Col span="2">
        <z-panelimg
          :del="false"
          :src="ossPrefix + orderModify.coverFile.key"
        ></z-panelimg>
      </Col>
      <Col span="10">
        <p>
          <span class="modify-head-name">{{ orderModify.name }}</span
          ><span class="modify-head">编号{{ orderModify.code }}</span>
        </p>
        <p class="modify-head">
          修改总款数：<span class="modify-head-qty">{{ orderModify.qty }}</span
          >款
        </p>
        <p class="modify-head">{{ orderModify.createTime | date }}</p>
      </Col>
      <Col span="2">
        <Badge
          class-name="modify-row-badge-wait"
          v-if="orderModify.confirmed === 0"
          :text="getConfirmText(orderModify.confirmed)"
        ></Badge>
        <Badge
          class-name="modify-row-badge-confirmed"
          v-if="orderModify.confirmed === 1"
          :text="getConfirmText(orderModify.confirmed)"
        ></Badge>
        <Badge
          class-name="modify-row-badge-cancel"
          v-if="orderModify.confirmed === 2"
          :text="getConfirmText(orderModify.confirmed)"
        ></Badge>
      </Col>
      <Col :span="orderModify.confirmed !== 0 ? '7' : '3'">
        <p style="text-align:right;">增减项费用:</p>
        <p
          style="text-align:right; font-weight: 500;
font-size: 14px; color:#EB5757;"
        >
          {{ orderModify.totalPrice | currency("¥", "2") }}
        </p>
      </Col>
      <Col
        :span="orderModify.confirmed !== 0 ? '3' : '7'"
        style="text-align:right"
      >
        <router-link
          :to="
            '/modify-details/' + orderModify.id + '?orderId=' + $route.params.id
          "
        >
          <Button size="small">查看详情</Button>
        </router-link>
        <Button
          style="margin-left:10px"
          size="small"
          v-if="orderModify.confirmed === 0"
          @click="cancelUpdateHandle(orderModify.id)"
          >取消修改</Button
        >
        <Button
          style="margin-left:10px"
          class="red-btn"
          size="small"
          type="primary"
          v-if="orderModify.confirmed === 0"
          @click="comfirmUpdateHandle(orderModify.id)"
          >确认修改</Button
        >
      </Col>
    </Row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "modifyList",
  props: {
    lists: {
      type: Array,
      default: function() {
        return [];
      }
    },
    allLists: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    /* 确认显示状态  确认状态(0:未确认,1:已确认,2:取消修改)*/
    getConfirmText(confirmed) {
      switch (confirmed) {
        case 0:
          return "待确认";
          break;
        case 1:
          return "已确认";
          break;
        case 2:
          return "已取消";
          break;
      }
    },

    /**
     * 是否需要显示确认修改单
     */
    getShowWaitConfirm(lists) {
      if (!lists || lists.length === 0) return false;
      let query = null;
      query = lists.filter(item => item.confirmed === 0);
      if (query && query.length > 0) {
        return query.length;
      } else {
        return 0;
      }
    },

    /* 取消修改单修改 */
    cancelUpdateHandle(id) {
      this.$Modal.confirm({
        title: "是否确定取消此修改单",
        loading: true,
        content: "<p>取消修改单后，将继续按照原产品信息进行生产定制。</p>",
        onOk: () => {
          this.cancelUpdate(id);
        }
      });
    },

    /* 确认修改 */
    comfirmUpdateHandle(id) {
      this.$Modal.confirm({
        title: "是否确认此修改单",
        loading: true,
        content:
          "<p>修改单一经确认，产品修改内容将覆盖原产品信息，相应增减项费用将计入尾款。</p>",
        onOk: () => {
          axios
            .put(`/designer_api/order_modify/${id}/confirmed`)
            .then(res => {
              this.$Message.success("确认成功");
              this.getShowWaitConfirm(this.allLists);
              this.$emit("reloadDetails");
              this.$Modal.remove();
            })
            .catch(err => {
              this.$Modal.remove();
            });
        }
      });
    },

    cancelUpdate(id) {
      axios
        .put(`/designer_api/order_modify/${id}/cancel`)
        .then(res => {
          this.$Message.success("取消成功");
          this.$emit("reloadDetails");
          this.$Modal.remove();
        })
        .catch(err => {
          this.$Modal.remove();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.modify {
  &-row {
    padding: 20px 32px;
    border-bottom: 1px solid #ddd;
    &:last-child {
      border: none;
    }
    &-badge-wait {
      background: #f7dfde !important;
    }
  }

  &-tip {
    background: rgba(247, 181, 0, 0.0812391);
    border-radius: 2px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    height: 52px;
    width: 100%;
    padding: 16px 24px;
    &-left {
      text-align: left;
    }
    &-right {
      text-align: right;
      float: right;
    }
  }
}

.modify-head {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #707070;
  padding: 8px;
  &-name {
    font-size: 18px;
    line-height: 18px;
    color: #313131;
    padding-left: 8px;
  }
  &-qty {
    color: black;
    padding-right: 4px;
  }
}

/deep/.modify-row-badge-wait {
  background: #f7dfde !important;
  margin-bottom: 60px;
  color: #eb5757;
}
/deep/.modify-row-badge-confirmed {
  background: rgba(68, 215, 182, 0.28) !important;
  margin-bottom: 60px;
  color: #44d7b6;
}
/deep/.modify-row-badge-cancel {
  background: #f1f1f1 !important;
  margin-bottom: 60px;
  color: #999999;
}
</style>
